import React from 'react';
import ContactForm from './ContactForm';


const Contact = () => {
   return (
      <section id='aboutMe'>
         <div className='discoverpianosection'>
            <div className='container px-3'>
               <div className='bottom-content mt-5 mb-5'>
                  <hr />
                  <div className='header-content w-75 mx-auto text-center mt-5'>
                     <h2>Begin Your Musical Journey at Quinn's Piano Studio</h2>
                     <h4>Reach out for more information: </h4>
                     <p className='mt-3'>Find the perfect mentor who will inspire and guide you on your musical odyssey.</p>
                  </div>
               </div>

               {/* Contact Form Starts */}
               <div className='getin-touch my-5'>
                  <ContactForm />
               </div>
               {/* Contact Form Ends */}

            </div>
         </div>
      </section>
   );
};

export default Contact;
